import React from 'react';
import PropTypes from 'prop-types';

import FormikInput from "components/input/new/FormikInput";

GeodisStringField.propTypes = {
    name: PropTypes.string.isRequired,
};

function GeodisStringField({name}) {
    return (
        <FormikInput
            required={true}
            name={`additionalData.${name}`}
            label={`shippingMethods.form.field.additionalData.${name}.label`}
            placeholder={`shippingMethods.form.field.additionalData.${name}.placeholder`}
        />
    );
}

export default GeodisStringField;
